module.exports = __webpack_public_path__ + "img/qilin-f-stage3.3ad1895b.png";